module.exports = __webpack_public_path__ + "static/media/IMG_0059.d4d176db.jpg";